import React from 'react';

const PreferredFuelStop = ({ keyValue, stop }) => {
  return (
    <React.Fragment>
      <tr>
        {keyValue === 1 ? (
          <td colSpan="3" className="fuel-stop-description-first">
            {stop.name}
          </td>
        ) : (
          <td colSpan="3" className="fuel-stop-description">
            {stop.name}
          </td>
        )}
      </tr>
      <tr>
        <td className="fuel-stop-address">
          {' '}
          {stop.address.street}, {stop.address.city}, {stop.address.state} {stop.address.zip}
          {(stop.route || stop.exit) && (
            <div className="fuel-stop-route-details">
              {stop.route && `Route: ${stop.route}`}
              {stop.route && stop.exit && ' · '}
              {stop.exit && `Exit: ${stop.exit}`}
            </div>
          )}
        </td>
        <td className="fuel-stop-distance-from-origin">
          <span className="fuel-stop-metric-label">Distance (mi)</span>
          {parseFloat(stop.distanceFromOrigin).toFixed(1)}
        </td>
        <td className="fuel-stop-distance-off-route">
          <span className="fuel-stop-metric-label">Off Route (mi)</span>
          {parseFloat(stop.distanceOffRoute).toFixed(1)}
        </td>
      </tr>
    </React.Fragment>
  );
};
export default PreferredFuelStop;
